import {
  FETCH_AUDIO_TRACKS,
  FETCH_AUDIO_TRACKS_SUCCESS,
  FETCH_AUDIO_TRACKS_FAILED,
  SAVE_AUDIO_TRACKS_TRANSCRIPT,
  SAVE_AUDIO_TRACKS_TRANSCRIPT_SUCCESS,
  SAVE_AUDIO_TRACKS_TRANSCRIPT_FAILED,
  LOGIN,
  LOGIN_FAILED,
  LOGIN_SUCCESS,
  UPLOAD_FILE_REQUEST,
  UPLOAD_FILE_REQUEST_SUCCESS,
  UPLOAD_FILE_REQUEST_FAILED,
  API_URL,
  FETCH_DASHBOARD,
  FETCH_DASHBOARD_SUCCESS,
  FETCH_DASHBOARD_FAILED,
  REGISTER,
  REGISTER_SUCCESS,
  REGISTER_FAILED,
  GET_COLLEGE_LIST,
  GET_COLLEGE_LIST_SUCCESS,
  GET_COLLEGE_LIST_FAILED,
} from "./../constants/constants";
import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";

function* fetchAudioTracks(action) {
  const {
    object: { username, start_date, end_date, start_page, end_page },
  } = action;
  const toPost = {
    user: username,
    start_date,
    end_date,
    start_page,
    end_page,
  };

  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/get-audio`, toPost, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: FETCH_AUDIO_TRACKS_SUCCESS, data: result });
  } catch (error) {
    yield put({ type: FETCH_AUDIO_TRACKS_FAILED, data: "error" });
  }
}

function* saveAudioTracks(action) {
  const { transcript, transcript_id, user, language } = action.object;
  const toPost = {
    user,
    transcript_id,
    transcript,
    language,
  };

  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/update-transcript`, toPost, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: SAVE_AUDIO_TRACKS_TRANSCRIPT_SUCCESS, data: result });
  } catch (error) {
    yield put({ type: SAVE_AUDIO_TRACKS_TRANSCRIPT_FAILED, data: error });
  }
}

function* isUserLoggedIn(action) {
  const { username, password } = action.object;

  const toPost = {
    username,
    password,
  };

  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/new-login-flow`, toPost, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: LOGIN_SUCCESS, data: result });
  } catch (error) {
    yield put({ type: LOGIN_FAILED, data: error });
  }
}

function* isAudioUploaded(action) {
  const toPost = new FormData();
  toPost.append("wavid", action.payload.wavid);
  toPost.append("userId", action.payload.userId);
  toPost.append("file", action.payload.file);
  try {
    let result = yield call(() =>
      axios.post(`${API_URL}/audio-upload`, toPost, {
        headers: {
          "Content-Type": "multipart/formdata",
          Accept: "application/json",
        },
      })
    );
    yield put({ type: UPLOAD_FILE_REQUEST_SUCCESS, data: result });
  } catch (error) {
    yield put({ type: UPLOAD_FILE_REQUEST_FAILED, data: error });
  }
}

function* fetchUserwiseData(action) {
  const { userId } = action;

  const toPost = {
    user_id: userId,
  };
  try {
    let result = yield call(() =>
      axios.post(`${API_URL}/user-wise-Dashboard`, toPost, {
        headers: {
          "Content-Type": "multipart/formdata",
          Accept: "application/json",
        },
      })
    );
    yield put({ type: FETCH_DASHBOARD_SUCCESS, data: result });
  } catch (error) {
    yield put({ type: FETCH_DASHBOARD_FAILED, data: error });
  }
}

function* registerNewUser(action) {
  const {
    LoginId,
    Password,
    BaseLanguage,
    OtherLanguages,
    UserPrivilege,
    Createdby,
    EmployeeName,
    ProductIds,
    TeamId,
    CollegeId,
  } = action.payload;
  const toPost = {
    LoginId,
    Password,
    BaseLanguage,
    OtherLanguages,
    UserPrivilege,
    Createdby,
    EmployeeName,
    ProductIds,
    TeamId,
    CollegeId,
  };
  try {
    let result = yield call(() =>
      axios.post(`${API_URL}/add-product-and-team`, toPost, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    if (result.data[0].Status === 0)
      yield put({ type: REGISTER_SUCCESS, data: result });
    else yield put({ type: REGISTER_FAILED, data: result.data[0] });
  } catch (error) {
    yield put({ type: REGISTER_FAILED, data: error });
  }
}

function* fetchCollegeList() {
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/Get-College-Details`)
    );
    yield put({ type: GET_COLLEGE_LIST_SUCCESS, data: result.data });
  } catch (error) {
    yield put({ type: GET_COLLEGE_LIST_FAILED, data: error });
  }
}

function* audioTrackSagas() {
  yield takeLatest(FETCH_DASHBOARD, fetchUserwiseData);
  yield takeLatest(FETCH_AUDIO_TRACKS, fetchAudioTracks);
  yield takeLatest(SAVE_AUDIO_TRACKS_TRANSCRIPT, saveAudioTracks);
  yield takeLatest(LOGIN, isUserLoggedIn);
  yield takeLatest(REGISTER, registerNewUser);
  yield takeLatest(GET_COLLEGE_LIST, fetchCollegeList);
  yield takeLatest(UPLOAD_FILE_REQUEST, isAudioUploaded);
}

export default audioTrackSagas;
